import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getGasFeesCurrencyList } from "../../redux/actions/gasFeesAction";
import { getNetworkGasFeeList } from "../../redux/actions/networkGasFeeAction";

export default function Index() {

    const history = useHistory();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        dispatch(getGasFeesCurrencyList(setLoading));
        dispatch(getNetworkGasFeeList(setLoading));
    }, [dispatch]);

    let { gasFees } = useSelector((state) => state.gasFees);
    let { networkGasFees } = useSelector((state) => state.networkGasFees);

    return {
        gasFees,
        networkGasFees
    };
}
